// Listas fijas estandarizadas
export const UNIDADES_MEDIDA = [
  // Generales / Ropa / Servicios (Añadidos estratégicos)
  { label: 'Unidad (UND)', value: 'UND' },
  { label: 'Pieza (PZA)', value: 'PZA' },       // Ideal para ropa suelta (camisas, pantalones)
  { label: 'Par (PAR)', value: 'PAR' },         // Zapatos, guantes, calcetines
  { label: 'Conjunto (CJT)', value: 'CJT' },    // Sudaderas, vestidos de baño, trajes
  { label: 'Docena (DOC)', value: 'DOC' },
  { label: 'Paquete (PQ)', value: 'PQ' },
  { label: 'Caja (CX)', value: 'CX' },
  { label: 'Kit / Combo (KIT)', value: 'KIT' }, // Promociones
  { label: 'Servicio (SRV)', value: 'SRV' },    // Arreglos, domicilios, asesorías
  { label: 'No Aplica (N/A)', value: 'N/A' },   // El salvavidas universal

  // Peso (Alimentos, Carnicerías, Ferreterías)
  { label: 'Kilogramo (KG)', value: 'KG' },
  { label: 'Gramo (GR)', value: 'GR' },
  { label: 'Miligramo (MG)', value: 'MG' },
  { label: 'Libra (LB)', value: 'LB' },
  { label: 'Onza (OZ)', value: 'OZ' },
  { label: 'Tonelada (TON)', value: 'TON' },

  // Volumen (Líquidos, Lácteos, Aseo)
  { label: 'Litro (LT)', value: 'LT' },
  { label: 'Mililitro (ML)', value: 'ML' },
  { label: 'Galón (GAL)', value: 'GAL' },
  { label: 'Centímetro Cúbico (CC)', value: 'CC' },

  // Longitud (Ferreterías, Textiles)
  { label: 'Metro (M)', value: 'M' },
  { label: 'Centímetro (CM)', value: 'CM' },
  { label: 'Milímetro (MM)', value: 'MM' },
  { label: 'Pulgada (IN)', value: 'IN' },
  { label: 'Pie (FT)', value: 'FT' },
  { label: 'Rollo (RLL)', value: 'RLL' }
];

export const OPCIONES_PRESENTACION = [
  // Universales y Ropa
  { label: 'No Aplica (N/A)', value: 'N/A' },
  { label: 'Prenda / Pieza', value: 'Prenda' },
  { label: 'Par', value: 'Par' },
  
  // Envases comunes
  { label: 'Bolsa', value: 'Bolsa' },
  { label: 'Caja', value: 'Caja' },
  { label: 'Botella', value: 'Botella' },
  { label: 'Frasco', value: 'Frasco' },
  { label: 'Lata', value: 'Lata' },
  { label: 'Sobre', value: 'Sobre' },
  { label: 'Vaso', value: 'Vaso' },

  // Empaques específicos
  { label: 'Blíster', value: 'Blister' },
  { label: 'Tubo', value: 'Tubo' },
  { label: 'Tarro', value: 'Tarro' },
  { label: 'Saco / Bulto', value: 'Bulto' },
  { label: 'Garrafa', value: 'Garrafa' },
  { label: 'Galón', value: 'Galon' },
  { label: 'Paca / Six-Pack', value: 'Paca' },

  // Ferretería / Varios
  { label: 'Metro / Retazo', value: 'Metro' }, // Útil también para telas
  { label: 'Rollo', value: 'Rollo' },
  { label: 'Galleta / Barra', value: 'Barra' },
  { label: 'Granel (Suelto)', value: 'Granel' }
];

export const UBICACIONES_PREDEFINIDAS = [
  { label: 'Exhibición / Vitrina', value: 'Exhibicion' },
  { label: 'Bodega Principal', value: 'Bodega_Principal' },
  { label: 'Mostrador', value: 'Mostrador' },
  { label: 'Nevera / Refrigeración', value: 'Nevera' },
  { label: 'Congelador', value: 'Congelador' },
  { label: 'Pasillo 1', value: 'Pasillo_1' },
  { label: 'Pasillo 2', value: 'Pasillo_2' },
  { label: 'Pasillo 3', value: 'Pasillo_3' },
  { label: 'Estante / Anaquel A', value: 'Estante_A' },
  { label: 'Estante / Anaquel B', value: 'Estante_B' },
  { label: 'Zona de Cajas (Impulso)', value: 'Zona_Cajas' }
];

// Función para obtener listas dinámicas desde los productos de la DB
export const obtenerListasDinamicas = (productos) => {
  const categoriasDB = productos.map(p => p.categoria).filter(Boolean);

  // CORRECCIÓN: Si p.proveedor es un string, lo toma directamente. 
  // Si es un objeto, toma el nombre.
  const proveedoresDB = productos.map(p => {
    if (typeof p.proveedor === 'object' && p.proveedor !== null) {
      return p.proveedor.nombre;
    }
    return p.proveedor; // Aquí es donde lee el string de la DB
  }).filter(Boolean);

  const ubicacionesDB = productos.map(p => p.ubicacion).filter(Boolean);

  return {
    listaCategorias: [...new Set(categoriasDB)],
    listaProveedores: [...new Set(proveedoresDB)],
    ubicacionesSugeridas: [...new Set([...ubicacionesDB, ...UBICACIONES_PREDEFINIDAS.map(u => u.value)])],
  };
};